/* eslint-disable camelcase */
import { Component } from 'react';
import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import IncentivePerformance from './subcomponents/incentive-performance';
import { currentUserGroup } from '../../../utils/tokenUtils';

import { Sell } from '../../common/icons';

import './style.css';

class SellIt extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false
    };
  }

  componentDidMount() {
    if (currentUserGroup() === 'staff') {
      this.setState({open: true});
    }
  }

  toggleContent = () => {
    this.setState({ open: !this.state.open });
  };

  dateConvert = (dateString) => {
    const date = new Date(dateString);
    const parsed = Date.parse(date);

    return parsed;
  };

  checkEnded = () => {
    const { data } = this.props;
    const dateNow = Date.now();
    const checkDate = (this.dateConvert(data.end_date) < dateNow || dateNow < this.dateConvert(data.start_date));

    return checkDate;
  };

  render() {
    const { data, label } = this.props;
    const { open } = this.state;

    return (
      <div className="user-performance-container">
        <div className="incentive-performances">
          <Card className={open ? 'panel-open' : 'panel-closed'}>
            <Card.Header>
              <div onClick={this.toggleContent} className="performance-header-container card-title">
                <div className="performance-header-section performance-title-section">
                  <Sell height={24} width={24} className="performance-icon" />
                  <h2 className="performance-name">{`${label} - ${data.name}`}</h2>
                  {data.locked && (
                    <OverlayTrigger
                      placement="left"
                      overlay={(
                        <Tooltip id="tooltip" className="tooltip">
                          This incentive is now closed and you can no longer earn points for selling these products.
                          Any points earned that have not yet been awarded will be awarded as soon as possible.
                        </Tooltip>
                      )}
                    >
                      <span className="glyphicon glyphicon-lock performance-lock" aria-hidden="true"></span>
                    </OverlayTrigger>
                  )}
                </div>
                <div className="performance-header-section">
                  <div className="maximum-points">
                    {open && (
                      this.checkEnded() ? (
                        <h2>Ended</h2>
                      ) : (
                        data.maximum_points && <h2>{`MAX POINTS ${data.maximum_points}`}</h2>
                      )
                    )}
                  </div>
                  <span className={`dropdown-arrow ${open && 'is-open'}`} />
                </div>
              </div>
            </Card.Header>
            {this.state.open && data && (
              <Card.Body>
                <IncentivePerformance
                  key={data.id}
                  data={data}
                />
              </Card.Body>
            )}
          </Card>
        </div>
      </div>
    );
  }
}

export default SellIt;
